import { EventEmitter } from '@angular/core';
import { InfoFieldSelectorModalDirective } from 'SecuritiesApp/ts/info-field-selector-modals/info-field-selector-modal/info-field-selector-modal.directive';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i2 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i3 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i4 from "SecuritiesApp/ts/info-field-selector-modals/shared/info-field-list/info-field-list.component";
/**
 * Single Info Field Selector Modal Component
 *
 * Modal that shows the static menu of info fields and lets a single info field be selected.
 * The modal closes on selection.
 *
 * Input Properties:
 *  infoType: 'company', 'fund', 'all', etc.
 *  selectedInfoField: info field that should start out as selected.
 *
 * Output Properties:
 *  selectInfoFieldHandler: emits the info field that was selected.
 */
export class SingleInfoFieldSelectorModalComponent extends InfoFieldSelectorModalDirective {
    constructor() {
        super(...arguments);
        this.selectInfoFieldHandler = new EventEmitter();
    }
    openModal() {
        this.modalOpen = true;
        if (this.selectedInfoField) {
            this.selectedInfoFields = [this.selectedInfoField];
        }
    }
    closeModal() {
        this.modalOpen = false;
    }
    selectInfoField(infoField) {
        if (this.selectedInfoFields.length && infoField.key === this.selectedInfoFields[0].key) {
            // Deselect the info field since the selected info field was clicked again
            this.selectedInfoFields = [];
        }
        else {
            if (this.featureService.validateFeatureNeeded([infoField], this.featureNeededModal).length > 0) {
                this.selectInfoFieldHandler.emit(infoField);
            }
            this.closeModal();
        }
    }
}
SingleInfoFieldSelectorModalComponent.ɵfac = /*@__PURE__*/ (() => { let ɵSingleInfoFieldSelectorModalComponent_BaseFactory; return function SingleInfoFieldSelectorModalComponent_Factory(__ngFactoryType__) { return (ɵSingleInfoFieldSelectorModalComponent_BaseFactory || (ɵSingleInfoFieldSelectorModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SingleInfoFieldSelectorModalComponent)))(__ngFactoryType__ || SingleInfoFieldSelectorModalComponent); }; })();
SingleInfoFieldSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleInfoFieldSelectorModalComponent, selectors: [["ycn-single-info-field-selector-modal"]], inputs: { selectedInfoField: "selectedInfoField" }, outputs: { selectInfoFieldHandler: "selectInfoFieldHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 7, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "resetModalHandler", "header", "resetModalText"], [1, "modal-body"], [3, "selectHandler", "infoType", "isSingleSelect", "modalOpen", "selectedInfoFields"], [1, "modal-footer"]], template: function SingleInfoFieldSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SingleInfoFieldSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SingleInfoFieldSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); })("resetModalHandler", function SingleInfoFieldSelectorModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { return ctx.resetModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "ycn-info-field-list", 3);
        i0.ɵɵlistener("selectHandler", function SingleInfoFieldSelectorModalComponent_Template_ycn_info_field_list_selectHandler_3_listener($event) { return ctx.selectInfoField($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Info Field")("resetModalText", "Reset");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("infoType", ctx.infoType)("isSingleSelect", true)("modalOpen", ctx.modalOpen)("selectedInfoFields", ctx.selectedInfoFields);
    } }, dependencies: [i1.ModalBaseComponent, i2.SimpleModalHeaderComponent, i3.FeatureNeededComponent, i4.InfoFieldListComponent], encapsulation: 2 });
